import Modal from "../../../shared/components/Modal";
import { useTranslation } from "react-i18next";
import {A} from "../../../shared/components/Typograhy";
import {faExternalLinkAlt} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export default function CgvReminder ({open, setOpen}){
    const { t } = useTranslation();

    return <Modal
            title={t('cgv.reminder')}
            open={open}
            setOpen={setOpen}
        >
        <p className="py-8">{t('cgv.reminder.description')}</p>
        <ul  className="divide-y">
            <li className="py-3 flex items-center"><FontAwesomeIcon className="mr-1 h-3.5 w-3.5 align-middle text-gray-600" icon={faExternalLinkAlt}/><A target="_blank" href="https://www.lamallepostale.com/fr/faq#section6-article4">Tarifs bagages "dernière minute"</A></li>
            <li className="py-3 flex items-center"><FontAwesomeIcon className="mr-1 h-3.5 w-3.5 align-middle text-gray-600" icon={faExternalLinkAlt}/><A target="_blank" href="https://www.lamallepostale.com/fr/faq#section4">Annulation et remboursement</A></li>
        </ul>
        </Modal>
}
